// SUPER ADMIN DASHBOARD > CompaniesListPage

import React from "react";
import CompaniesListLayer from "../components/CompaniesListLayer";
import SuperAdminDashLayout from "../masterLayout/SuperAdminDashLayout";

const CompaniesListPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <SuperAdminDashLayout>
        {/* AddUserLayer */}
        <CompaniesListLayer />
      </SuperAdminDashLayout>
    </>
  );
};

export default CompaniesListPage;
